export default __webpack_public_path__ + "static/media/NBAPopupBg.c238abf4.png";